module.exports = __webpack_public_path__ + "img/transcript_felc_new.7d132eca.jpg";